import { ViewProps } from 'react-native';
import styled from 'styled-components/native';

export type ContentViewProps = ViewProps & {
  short?: boolean;
  fullHeight?: boolean;
};

/**
 * Wrapped content contains standard padding
 * @param short remove vertical padding
 * @param fullHeight maximize the height to fill the container; this is useful
 *    for child component spacing
 */
const ContentView = styled.View<ContentViewProps>`
  padding: ${p => (p.short ? 0 : 24)}px 24px;
  flex-grow: ${p => (p.fullHeight ? 1 : 0)};
  width: 100%;
`;
/* NOTE: this could come in handy for even vertical distribution within a view */
/* justify-content: ${p =>
    p.fullHeight ? 'space-between' : 'flex-start'}; */

export default ContentView;
